const present = (value) => value !== null && value !== undefined && String(value).trim() !== "";
const integer = (value) => {
  if (!present(value) || !/^\d+$/.test(String(value))) return null;
  const parsed = Number(value);
  return Number.isSafeInteger(parsed) ? parsed : null;
};

export const emptyResourceRequirement = () => ({ resource_id: "", hold_type: "whole", duration_minutes: "" });

export const normalizeResourceRequirements = (rows) => (Array.isArray(rows) ? rows : [])
  .filter((row) => row && integer(row.resource_id) > 0)
  .map((row, index) => {
    const holdType = row.hold_type === "partial" ? "partial" : "whole";
    const normalized = {
      resource_id: integer(row.resource_id),
      hold_type: holdType,
      duration_minutes: holdType === "partial" ? integer(row.duration_minutes) : null,
      position: index + 1,
    };
    const id = integer(row.id);
    return id > 0 ? { id, ...normalized } : normalized;
  });

export const resourceRequirementsFromService = (service = {}) => {
  const source = Array.isArray(service.resource_requirements)
    ? service.resource_requirements
    : (present(service.resource_id) ? [{ resource_id: service.resource_id, hold_type: "whole" }] : []);
  return normalizeResourceRequirements([...source].sort((left, right) => Number(left?.position || 0) - Number(right?.position || 0)));
};

export const moveResourceRequirement = (rows, index, direction) => {
  const result = [...(Array.isArray(rows) ? rows : [])];
  const target = index + direction;
  if (index < 0 || index >= result.length || target < 0 || target >= result.length) return result;
  [result[index], result[target]] = [result[target], result[index]];
  return result;
};

export const resourceRequirementErrors = (rows, serviceDuration) => {
  const errors = {};
  const seen = new Set();
  const maximum = integer(serviceDuration);
  (Array.isArray(rows) ? rows : []).forEach((row, index) => {
    const rowErrors = {};
    const resourceId = integer(row?.resource_id);
    if (!resourceId) rowErrors.resource_id = "Choose a resource.";
    else if (seen.has(resourceId)) rowErrors.resource_id = "Each resource can only be required once.";
    else seen.add(resourceId);
    if (row?.hold_type === "partial") {
      const duration = integer(row.duration_minutes);
      if (!duration || duration <= 0) rowErrors.duration_minutes = "Enter a positive duration.";
      else if (maximum && duration > maximum) rowErrors.duration_minutes = "Duration cannot exceed the service duration.";
    }
    if (Object.keys(rowErrors).length) errors[index] = rowErrors;
  });
  return errors;
};

const resourceName = (row) => row?.resource_name || row?.resource?.resource_name || row?.resource?.name || row?.name || "Resource";

export const summarizeResourceRequirements = (rows) => (Array.isArray(rows) ? rows : [])
  .map((row) => row?.hold_type === "partial"
    ? `${resourceName(row)} (${Number(row.duration_minutes)} min)`
    : `${resourceName(row)} (whole service)`)
  .join(", ");
